export const invoicesRouteNames = {
  listInvoices: 'payment-products-list-invoices',
  listRecurringInvoices: 'payment-products-list-recurring-invoices',
  listInvoiceTemplates: 'invoice-templates',
  importInvoices: 'payment-products-import-invoices',
  invoiceEditor: 'payment-products-invoice-editor',
  invoiceTemplateEditor: 'payment-products-invoice-template-editor',
  recurringInvoiceEditor: 'payment-products-recurring-invoice-editor',
  invoiceSettings: 'invoice-settings',
  invoiceLayoutCustomization: 'invoice-customization',
}
